import {useAccount, useSwitchChain} from "wagmi";
import {ritualChain, RITUAL_CHAIN_ID} from "@/lib/chain";

/**
 * If the connected wallet is on the wrong network, render a switch prompt instead
 * of the children. wagmi's useSwitchChain issues wallet_switchEthereumChain; if the
 * chain isn't known to the wallet, RainbowKit/addEthereumChain flow handles adding it.
 */
export function ChainGuard({children}: {children: React.ReactNode}) {
  const {chain, isConnected} = useAccount();
  const {switchChain, isPending} = useSwitchChain();

  if (isConnected && chain?.id !== RITUAL_CHAIN_ID) {
    return (
      <div className="panel p-4 flex flex-col items-start gap-2">
        <p className="text-sm text-molten-300">
          Wrong network. Smelt runs on Ritual Chain (id {RITUAL_CHAIN_ID}).
        </p>
        <button
          className="btn-primary"
          onClick={() => switchChain({chainId: ritualChain.id})}
          disabled={isPending}
        >
          {isPending ? "Switching..." : "Switch to Ritual Chain"}
        </button>
      </div>
    );
  }
  return <>{children}</>;
}
